export default {
  'sf-hackathon-2023': {
    nav: {
      sign: '报名参赛',
      topic: '大赛简介',
      awards: '奖项设置',
      agenda: '议程安排',
      selection: '作品评选',
      guest: '嘉宾评委',
      partner: '合作伙伴'
    },
    section1: {
      title: 'SegmentFault AI Hackathon 2023',
      content: `
              <p>
                    ChatGPT 在全球范围内掀起了一场关于 AI 技术革命的狂潮，被疫情按下暂停键的 SegmentFault Hackathon
                    也带着全新的 AI 主题重磅回归！
                  </p>
  
                  <p>TALK IS CHEAP, SHOW ME THE CODE !!!</p>
  
                  <p>
                    在 SegmentFault AI Hackathon 2023 中，我们鼓励开发者大开脑洞，
                    <strong class="text-primary">
                      结合日常生活中的痛点需求、兴趣爱好和专业方向，进行 Generative AI 应用的构建。
                    </strong>
                  </p>
  
                  <p>
                    比赛将持续 32 小时，参赛者在此时间内以小组为单位完成创意脑暴、产品设计、代码实现和 Demo
                    展示，大赛评审团将根据应用程序的创新性、技术难度、应用场景、用户体验和商业价值等因素进行评分。获奖团队不仅会获得大赛的高额奖金，还有机会获得更广泛的关注和投资。此外，大赛还将邀请人工智能领域的技术大牛和社区领袖，为参赛者们提供专业的建议和支持，以促进这一领域的技术和应用的进一步发展。
                  </p>
              `
    },
    section2: {
      title: '黑客马拉松城市巡回'
    },
    section3: {
      title: '奖项设置',
      text1: '一等奖，1 组',
      text2: '二等奖，1 组',
      text3: '三等奖，1 组',
      text4: '思否 11 周年特别奖，1 组',
      text5: '最佳人气奖，1 组',
      text6: '最佳创意奖，1 组',
      text7: '技术创新奖，1 组'
    },
    section4: {
      title: '议程安排',
      description: '每场比赛持续 2 天，共计约 32 小时',
      text1: '签到入场',
      text2: '开幕式',
      text3: '选手组队 & 午餐休息',
      text4: '作品开发',
      text5: '晚餐',
      text6: '作品开发 & 夜宵休息',
      text7: '早餐',
      text8: '作品提交 & 路演测试',
      text9: '午餐',
      text10: '作品路演',
      text11: '茶歇',
      text12: '颁奖典礼 & 自由交流'
    },
    section5: {
      title: '作品评选',
      description: '评委会根据「完成度」「创意度」「技术难度」「商业价值」 4个维度进行考量',
      text1: '完成情况',
      text2: '参赛团队提供的作品的完整性及完成度，包括代码质量、视觉设计等',
      text3: '项目创新',
      text4: '参赛作品的创新性，同类技术场景下是否具有差异性',
      text5: '技术难度',
      text6: '参赛作品所应用的技术是否具有领先性和突破性',
      text7: '商业价值',
      text8: '参赛作品的技术、服务模式是否具备商业潜力，能否给产业带来积极影响'
    },
    section6: {
      title: '嘉宾评委',
      text1: '专家评委团',
      text2: '投资评委团',
      text3: '行业观察团'
    },
    section7: {
      title: '报名参赛',
      title1: '参赛对象',
      text1: '在职或高校开发者、创业者均可，我们鼓励开发者使用 Generative AI 技术构建创新应用和解决实际问题。',
      title2: '参与报名',
      text2:
        '本次比赛要求组队参加，每个团队 1-5 人，团队最高人限 5 人，1 人只能参与 1 个团队。开发者以个人身份报名，团队的每个成员都要单独报名。',
      title3: '作品提交',
      text3: '使用 Generative AI 技术开发，并按时提交至主办方统一指定平台。',
      text4: '参赛团队提交的所有参赛作品应且务必保证原创，抄袭、剽窃其他项目作品者，一经发现核实将取消参赛资格。',
      text5: '添加思否小姐姐：',
      text6: '扫码进群交流 “SF AIGC Hackathon 杭州站选手群”',
      text7: '商务合作咨询：'
    },
    section8: {
      title: '过往优秀作品'
    },
    section9: {
      title: '合作伙伴',
      title1: '主办单位',
      title2: '联合主办方及战略合作伙伴',
      title3: '共创伙伴',
      title4: '投资观察团',
      title5: '合作媒体及社区'
    }
  }
}
